var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-content-presentation"},[(_vm.getHackathonSlide)?_c('iframe',{staticClass:"edit-iframe",attrs:{"src":`${_vm.getHackathonSlide.editorUrl}?presentationId=${_vm.presentation.id}&slideId=${_vm.slideActive.id}&isPresenting=${_vm.isPresenting}`,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }